<template>
    <table class="schemeTable" cellspacing="0" cellpadding="0" border="0">
        <thead>
            <tr>
                <th :colspan="type=='person'||type=='oldPerson'?5:4">方案选择</th>
            </tr>
            <tr>
                <th :colspan="type=='person'||type=='oldPerson'?2:1">保障计划</th>
                <th>计划一</th>
                <th>计划二</th>
                <th v-if="quoteVersion==1">计划三</th>
            </tr>
            <tr>
                <th :colspan="type=='person'||type=='oldPerson'?2:1">赔偿限额</th>
                <th>50万+5万</th>
                <th>80万+10万</th>
                <th v-if="quoteVersion==1">100万+15万</th>
            </tr>
            <tr v-if="type=='person'||type=='oldPerson'">
                <th rowspan="2">保费报价</th>
                <th>{{type=='oldPerson'?'基础班':'方案一'}}</th>
                <th>{{type=='oldPerson'?490:price.plan1[0]}}</th>
                <th>{{type=='oldPerson'?690:price.plan2[0]}}</th>
                <th v-if="quoteVersion==1">{{type=='oldPerson'?790:1100}}</th>
            </tr>
            <!-- <tr>
                <th v-if="type=='person'||type=='oldPerson'">{{type=='oldPerson'?'扩展版':'方案二'}}</th>
                <th v-if="type=='car'">保费报价</th>
                <th>{{type=='oldPerson'?700:price.plan1[1]}}</th>
                <th>{{type=='oldPerson'?850:price.plan2[1]}}</th>
                <th v-if="quoteVersion==1">{{type=='oldPerson'?1000:1200}}</th>
            </tr> -->
        </thead>
    </table>
</template>
<script>
export default {
    props:{
        type:{
            type:String,
            default:'person'// oldPerson老版按人，person按人，car按车
        },
		quoteVersion:{
			type:Number,
			default:function() {
				return 3
			}
		}
    },
	computed:{
		price () {
			if (this.quoteVersion==1) {
				return {
					plan1:[630,720],
					plan2:[900,1000]
				}
			}
			if (this.quoteVersion==2) {
				return {
					plan1:[819,1080],
					plan2:[1170,1500]
				}
			}
            if (this.quoteVersion==3) {
				return {
					plan1:[901,1080],
					plan2:[1287,1500]
				}
			}
		}
	}
}
</script>
<style scoped lang="less">
.schemeTable{
    width: 100%;
    border-left: 1px solid #e8eaec;
    background: #f8f8f9;
    font-size: 14px;
    color: #515a6e;
    th{
        border-right: 1px solid #e8eaec;
        border-top: 1px solid #e8eaec;
        height: 48px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/truckEmployer/common/SchemeTable.vue